// 组件
import { MenuOutlined } from "@ant-design/icons";
// 方法
import { SortableHandle } from "@yonboo/react-sortable-hoc";
import classNames from "classnames";
// 常量
import { DragHandleProps } from "../interface";

const DragHandle = SortableHandle((props: DragHandleProps) => {
  const { className, style, render } = props;
  const classes = classNames('yb-sort-handle', className);
  return (
    <div className={classes} style={style}>
      {render || <MenuOutlined />}
    </div>
  );
});

export default DragHandle;